import { useTranslation } from 'react-i18next'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { ModalBodyText } from './styled'

interface IProps {
  isOpen: boolean
  processing?: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteAttestationModal = ({
  isOpen,
  processing = false,
  onClose,
  onConfirm,
}: IProps) => {
  const { t } = useTranslation()
  const prefix = 'administration.certificate.legalAttestationsList.deleteModal'

  return (
    <Modal
      isOpen={isOpen}
      title={t(`${prefix}.title`)}
      isConfirmation
      maxwidth={800}
      maxheight={204}
      close={onClose}
      actions={
        <ModalButtons
          secondaryText={t(`${prefix}.cancel`)}
          secondaryAction={onClose}
          disableSecondaryButton={processing}
          primaryText={t(`${prefix}.confirm`)}
          primaryAction={onConfirm}
          disablePrimaryButton={processing}
          isDangerous
          processing={processing}
          iconPrimary={faTrash}
          iconPrimaryPosition="start"
        />
      }
    >
      <ModalBodyText>{t(`${prefix}.description`)}</ModalBodyText>
    </Modal>
  )
}

export default DeleteAttestationModal
